import IThreeFiberComponent from "../../interfaces/IThreeFiberComponent";
import { CAMERA_CONFIG } from "../../configs/CAMERA_CONFIG";
import { Canvas } from "@react-three/fiber";
import ControlPanel from "./../ControlPanel";
import { useEffect } from "react";
import { initializeStripesFirstRender } from "../../helpers/initializeScene";
import ExhibitorsMap from "../Exhibitors-map/ExhibitorsMap";
import FooterSection from "../NavigationMenu/FooterSection";
import { detectSafari } from "../../helpers/detectSafari";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";

declare global {
  interface Window {
    ApplePaySetupFeature: any;
    safari: any;
  }
}

const Scene = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | IThreeFiberComponent;
}) => {
  const { setIsSafariBrowser, setIsSideNavOpen } =
    useComponentLoadingStateStore();
  const { fov, position } = CAMERA_CONFIG;

  useEffect(() => {
    initializeStripesFirstRender();
    const isSafari =
      (!!window.ApplePaySetupFeature || !!window.safari) &&
      detectSafari("Safari") &&
      !detectSafari("Chrome") &&
      !detectSafari("CriOS");
    if (isSafari) {
      setIsSafariBrowser(true);
      return;
    }
    setIsSafariBrowser(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      <ControlPanel />
      <Canvas
        camera={{
          fov: fov,
          position: [position[0], position[1], position[2]],
          rotation: [-0.3, 0, 0],
        }}
        dpr={[2, 2]}
        onMouseDown={() => setIsSideNavOpen(false)}
      >
        <>
          {ControlPanel.r3f()}
          {ExhibitorsMap.r3f()}
          {FooterSection.r3f()}
          <ambientLight intensity={0.5} />
          <directionalLight position={[0, 20, 20]} intensity={1} />
          {children}
        </>
      </Canvas>
    </div>
  );
};

export default Scene;
